import { useIsFetchingV5 } from './adapters/useIsFetchingV5';
import { QueryFilters } from './types';

export function useDataIsFetching(filters?: QueryFilters) {
	return useIsFetchingV5(filters);
}
